
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/accounting-and-payments",
      function () {
        return require("private-next-pages/solutions/accounting-and-payments/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/accounting-and-payments"])
      });
    }
  